import { normalizeResult } from "./normalizeSemantic";
import { SympyParser } from "./sympy-parser";

import type { SympyResult } from "./types";
import type { NodeJson } from "@corca/data";

/** Throws SympyParseError for results it cannot read; the host decides how to report that. */
export function parseSympyResult(
  sympy: SympyResult,
  opts?: { signed?: boolean; parent?: SympyResult; grouped?: boolean },
  symbolNodes?: Map<string, NodeJson>,
  preferDecimal?: boolean,
): { nodes: NodeJson[]; warnings: string[] } {
  const parser = new SympyParser(symbolNodes, preferDecimal);
  const nodes = parser.parseResult(normalizeResult(sympy), opts);
  return { nodes, warnings: parser.warnings };
}
